import { connect } from 'react-redux';

import CaseAmendingBaselineUpdateComponent from
  './../Components/CaseAmendingBaselineUpdateComponent.jsx';
import { modal as modalActions } from './../actions';
import { getModalVisibility } from './../reducers';
import { owners } from './../helpers/modals';

export const mapStateToProps = (state) => {
  return { visible: getModalVisibility(state, owners.caseAmendingBaseline) };
};

export default connect(
  mapStateToProps,
  { onHide: () => modalActions.showCaseAmendingBaselineUpdateModal(false, '') }
)(CaseAmendingBaselineUpdateComponent);


// WEBPACK FOOTER //
// src/Containers/CaseAmendingBaselineUpdateContainer.jsx